import SubBrandPage from "@/components/SubBrandPage";

export default function Nightclub() {
  return (
    <SubBrandPage meta={{
      slug: "nightclub",
      tag: "Party",
      title: "The Social Nightclub.",
      tagline: "Turn any space into your own private nightlife experience with our inflatable nightclub rentals.",
      heroImg: "/media/nightclub.jpg",
      overview: "Two inflatable rental options. Full nightclub energy. Anywhere you want it.",
      ctaLabel: "Reserve Your Nightclub",
      packages: [
        {
          name: "Lit Lounge", price: 500, priceLabel: "Flat rate",
          meta: "Inflatable nightclub rental",
          includes: [
            "Inflatable nightclub rental",
            "Delivery and professional setup",
            "Interior lighting",
            "Onsite crew during setup",
          ],
          footnote: "Ideal for backyards, rooftops, and larger private spaces.",
        },
        {
          name: "Luxe Lounge", price: 425, priceLabel: "Flat rate",
          meta: "Inflatable nightclub rental",
          includes: [
            "Inflatable nightclub rental",
            "Delivery and professional setup",
            "Interior lighting",
            "Onsite crew during setup",
          ],
          footnote: "Compact, lounge-forward setup — perfect for intimate gatherings.",
        },
      ],
      pricingNote: "Prices shown are flat rental rates. St. Louis-area events include an additional $75 travel fee.",
      sections: [
        { title: "What's Included",
          items: ["Delivery + professional setup", "Onsite crew during setup", "Interior lighting package", "Standard rental up to 6 hours"] },
        { title: "Delivery & Power",
          copy: "Both units require standard 120V outlets within 50 ft. Flat, dry surface required for setup. Delivery included within our Chicago service radius; St. Louis-area events add a $75 travel fee." },
      ],
      faqs: [
        { q: "How long does setup take?", a: "About 25–45 minutes depending on the unit. Add buffer time for full lighting/sound integration." },
        { q: "Can we use them outdoors?", a: "Yes, weather permitting. We monitor wind and precipitation and will coordinate a plan B if conditions aren't safe." },
        { q: "Can I pair it with a DJ or bar?", a: "Absolutely — pair with The Social Set or The Social Bar for a full Simply Social experience. Bundled pricing available by custom quote." },
      ],
    }} />
  );
}
